import React, { useState } from "react";
import { motion } from "framer-motion";
import ProductDetailsPopup from "./Productdetailspopup"; // New component for the popup
import { getImageUrl } from "../../utils/helper";
import AnalyticsService from "services/analytics.service";
import { EVENT_NAME } from "utils/constants";
import { TimeUtils } from "utils/time.utils";
import CustomerProductDetailsPopup from "./CustomerProductDetailsPopup";
import { Link } from "react-router-dom";

const CustomerProductCard = ({ product }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
  // const [rating] = useState(Math.floor(Math.random() * 5) + 1);
  return (
    <>
      <motion.div
        className="product-card"
        key={product.id}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <img
          src={getImageUrl(product.imageUrl)}
          alt={product.title}
          className="product-image"
          onClick={() => setIsPopupOpen(true)} // Open popup on image click
        />
        <div className="product-info" style={{ textAlign: "left" }}>
          <h2 className="product-name">{product.title}</h2>
          {product.customerAddress && (
            <div>
              City: <b>{product.customerAddress?.city}</b>
            </div>
          )}

          <p className="product-price">
            {product.sellingPrice !== product.listingPrice && (
              <span className="original-price">₹{product.listingPrice}</span>
            )}

            <span className="final-price">₹{product.sellingPrice}</span>
          </p>
          <div style={{display: "flex", justifyContent: "space-between"}}>
          <Link
            className="add-to-cart-btn"
            to={`/customer-products/${product.postType}/${product.id}`}
            onClick={() => {
              AnalyticsService.trackEvent(EVENT_NAME.CUSTOMER_PRODUCT_VIEWED, {
                areaId: product.areaId,
                customerProductId: product.id,
                postType: product.postType,
                title: product.title,
                description: product.description,
                sellingPrice: product.sellingPrice,
                listingPrice: product.listingPrice,
                createdAt: product.createdAt,
              });
            }}
          >
            View
          </Link>
          <div>

            {TimeUtils.formatTime(product.createdAt, 'DD MMM')}
          </div>
          </div>
        </div>
      </motion.div>

      {/* Product Details Popup */}
        {/* {isPopupOpen && (
        <CustomerProductDetailsPopup
          product={product}
          onClose={() => setIsPopupOpen(false)} // Close popup
        />
      )} */}
    </>
  );
};

export default CustomerProductCard;
